
<template>
  <div
    class="monitor"
    style="font-size: 16px; width: 100%; background: #eff1f5"
  >
    <div class="content">
      <div class="yuliang" ref="yuliang" style="margin-top: 0">
        <div class="select" ref="districtrainOperation">
          <span class="desc">起止时间:</span>
          <div style="display: inline-block">
            <el-date-picker
              v-model="query.begTime"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              @change="Global.emptyQuery(query.begTime, getData)"
              type="datetime"
              placeholder="选择开始时间"
              default-time="08:00:00"
              :clearable="true"
              :editable="false"
              :picker-options="pickerOptions0"
            ></el-date-picker>
            <span class="desc">至</span>
            <el-date-picker
              v-model="query.endTime"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="选择结束时间"
               @change="Global.emptyQuery(query.endTime, getData)"
              default-time="08:00:00"
              :clearable="true"
              :editable="false"
              :picker-options="pickerOptions1"
            ></el-date-picker>
          </div>
          <span id="select" @click="searchData">查询</span>
          <span id="add" @click="add">
            <span class="add-icon"></span>新增
          </span>
        </div>
        <div class="tableDiv" ref="tableDiv">
          <el-table
            v-loading="false"
            highlight-current-row
            :data="tdata"
            border
            :height="height"
            style="width: 100%"
          >
            <el-table-column
              type="index"
              width="70"
              label="序号"
              align="center"
              header-align="center"
            >
            </el-table-column>
            <el-table-column
              prop="time"
              align="center"
              header-align="center"
              label="时间"
              min-width="100"
            >
            </el-table-column>
            <el-table-column label="原文件"  align="center" header-align="center">
              <template slot-scope="scope">
                <svg
                  @click="download(scope.row)"
                  class="icon"
                  aria-hidden="true"
                  style="cursor: pointer;"
                >
                  <use xlink:href="#iconWORD" />
                </svg>
              </template>
        </el-table-column>
        <el-table-column label="操作" min-width="30" align="center" header-align="center">
          <template slot-scope="scope">
              <span id = "del" @click="del(scope.row)">
                <span class="del-icon"></span>删除
              </span>
          </template>
        </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <waterInfoForm ref="waterInfoForm" @getData="getData"></waterInfoForm>
  </div>
</template>
<script>
import waterInfoForm from './waterInfoForm'
import reportAnalysisTypes from '@/store/types/reportAnalysis'
import config from '@/config'
import timer from '@/utils/timer'
export default {
  components: { waterInfoForm },
  data () {
    return {
      loading: true,
      timerFun: '',
      query: {
        begTime: '',
        endTime: ''
      },
      tdata: [],
      height: 10,
      pickerOptions0: {
        disabledDate: (time) => {
          if (this.query.endTime) {
            return time.getTime() > new Date(this.query.endTime).getTime()
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      pickerOptions1: {
        disabledDate: (time) => {
          if (this.query.begTime) {
            return time.getTime() < new Date(this.query.begTime).getTime() - 8.64e7 || time.getTime() > Date.now()
          } else {
            return time.getTime() > Date.now()
          }
        }
      }
    }
  },
  methods: {
    searchData () {
      this.getData()
    },
    async getData () {
      this.loading = true
      let result = await this.$store.dispatch(
        reportAnalysisTypes.GET_LIST_RAIN_WATER_NOTICE,
        this.query
      )
      this.tdata = result.rows
      this.loading = false
    },
    add () {
      let now = new Date()
      this.$refs['waterInfoForm'].query.Time = this.$moment(now).format('YYYY-MM-DD HH:mm:00')
      this.$refs['waterInfoForm'].street = ''
      this.$refs['waterInfoForm'].isShow = true
    },
    download (row) {
      window.open(`${config.ApiYJ}${row.files}`)
    },
    del (row) {
      this.$confirm(`确定要删除当前雨水情告知单文件吗?`, '确认').then(() => {
        this.loading = true
        this.$store.dispatch(reportAnalysisTypes.DELETE_RAIN_WATER_NOTICE, {
          ids: row.id
        }).then(() => {
          this.loading = false
          this.$notify.success({ title: '成功', message: '删除水情信息文件成功.' })
          this.getData()
        }).catch(() => {
          this.loading = false
          this.$notify.error({ title: '失败', message: '删除水情信息文件失败' })
        })
      }).catch(() => {})
    },
    getTime () {
      let now = new Date()
      let preDate = new Date(now.getTime() - 1000 * 60 * 60 * 24 * 7) // 前一周
      this.query.begTime = this.$moment(preDate).format('YYYY-MM-DD HH:00')
      this.query.endTime = this.$moment(now).format('YYYY-MM-DD HH:00')
    }
  },
  created () {
    this.getTime()
  },
  mounted () {
    this.getData()
    this.timerFun = setInterval(() => {
      this.getTime()
      this.getData()
    }, timer.TIMER_MIN)
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      this.$refs['yuliang'].style.height =
        contentDiv[0].offsetHeight - 30 + 'px'
      this.$refs['tableDiv'].style.height =
        this.$refs['yuliang'].offsetHeight -
        10 -
        this.$refs['districtrainOperation'].offsetHeight +
        'px'
      this.height = this.$refs['tableDiv'].style.height
    })
  },
  beforeDestroy () {
    clearInterval(this.timerFun)
  }
}
</script>
<style lang="less" scoped>
.monitor {
  overflow: hidden;
   .tableDiv{
        margin-top: 5Px;
        width:98%;
        margin-left: 1%;
        overflow: auto;
         #del{
          padding: 9px 8px;
          background-color: #fda72c;
          cursor: pointer;
          float: right;
          color: #ffffff;
          border-radius: 3px;
          margin-right: 80px;
          font-size:16px;
        }
        .del-icon{
          width: 18px;
          height: 17px;
          display: inline-block;
          background-image: url('~@/assets/monitorimg/del.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          margin-right: 5px;
          vertical-align: middle;
        }
      }
        /* 样式穿透 */
      .tableDiv /deep/ .el-table th>.cell{
        // text-align: center !important;
        font-family: Microsoft YaHei UI !important;
        font-size: 15px !important;
        color: #333333 !important;
      }
      .tableDiv /deep/ .el-table td>.cell{
        // text-align: center !important;
        font-family: Microsoft YaHei UI !important;
        font-size: 15px !important;
        color: #666666 !important;
      }
      .tableDiv /deep/ .el-table tr:nth-child(even) {
        background: #eaf1fa;
      }
      .tableDiv /deep/ .el-table th {
        background: #F5F7FA!important;
        width: 50px;
      }
       .operationBtn{
        display: flex;
        justify-content: center;
        span{
          margin-right: 0px;
        }
  }
}
</style>
<style lang="less" scoped>
  body{
  background-color: #f0f2f6;
  margin: 0;
  padding: 0 0 10px 0;
}
.monitor{
  position: relative;
  // top: -80px;
  height: 100%;
  .content{
    padding: 15Px;
    height: 100%;
    .countryList{
      height: 62px;
      background-color: #ffffff;
      border-radius: 5px;
      color: #444444;
      font-size: 15px;
      .country{
        float: left;
        font-family: Microsoft YaHei UI;
        font-size: 15px;
        text-align: center;
        margin-top: 20px;
        margin-left: 0.15%;
        cursor: pointer;
        .countryon, .categoryon{
          border-radius: 15px;
          background-color: #fda72c;
          color: #ffffff
        }
        span{
          padding: 4px 12px;
        }
      }
    }
    .yuliang{
      background-color: #ffffff;
      /* float: left; */
      width: 100%;
      height: 680px;
      margin-top: 15Px;
      border-radius: 5px;
      .select{
        width: 100%;
        padding-top: 15Px;
        .before,.next,#select{
          padding: 10px 18px;
          background-color: #3d72fb;
          cursor: pointer;
          /* float: left; */
          font-size:16px;
          color: #ffffff;
          border-radius: 3px;
          margin-left: 13px;
        }
        .desc{
          font-size:16px;
          font-family:Microsoft YaHei UI;
          margin-left: 20px;
          margin-top: 5px;
          color:#444444;
          margin-right: 18px;
          line-height: 26px;
        }
        #export{
          padding: 9px 8px;
          background-color: #3d72fb;
          cursor: pointer;
          float: right;
          color: #ffffff;
          border-radius: 3px;
          margin-right: 20px;
          font-size:16px;
        }
        .export-icon{
          width: 18px;
          height: 17px;
          display: inline-block;
          background-image: url('~@/assets/monitorimg/export.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          margin-right: 5px;
          vertical-align: middle;
        }
        #add{
          padding: 9px 8px;
          background-color: #3d72fb;
          cursor: pointer;
          float: right;
          color: #ffffff;
          border-radius: 3px;
          margin-right: 20px;
          font-size:16px;
        }
        .add-icon{
          width: 18px;
          height: 17px;
          display: inline-block;
          background-image: url('~@/assets/monitorimg/add.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          margin-right: 5px;
          vertical-align: middle;
        }
        #del{
          padding: 9px 8px;
          background-color: #fda72c;
          cursor: pointer;
          float: right;
          color: #ffffff;
          border-radius: 3px;
          margin-right: 20px;
          font-size:16px;
        }
        .del-icon{
          width: 18px;
          height: 17px;
          display: inline-block;
          background-image: url('~@/assets/monitorimg/del.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          margin-right: 5px;
          vertical-align: middle;
        }
      }
      .raintable{
        margin-top: 5Px;
        width:98%;
        margin-left: 1%;
      }
        /* 样式穿透 */
      .raintable /deep/ .el-table th>.cell{
        // text-align: center !important;
        font-family: Microsoft YaHei UI !important;
        font-size: 15px !important;
        color: #333333 !important;
      }
      .raintable /deep/ .el-table td>.cell{
        // text-align: center !important;
        font-family: Microsoft YaHei UI !important;
        font-size: 15px !important;
        color: #666666 !important;
      }
      .raintable /deep/ .el-table tr:nth-child(even) {
        background: #eaf1fa;
      }
      .raintable /deep/ .el-table th {
        background: #F5F7FA!important;
        width: 50px;
      }
    }
  }
}
</style>
